export default [
    {
        name: '__slot:backlinks_toppages_url',
        sortField: 'url',
        type: 'string',
        defaultSearch: true,
        useInFilter: true,
    },
    {
        name: 'numdomain',
        sortField: 'numdomain',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: '__slot:backlinks_toppages_numurl',
        sortField: 'numurl',
        type: 'number',
        useInFilter: true,
        defaultSearch: true,
    },
    {
        name: 'numlink',
        sortField: 'numlink',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'numip',
        sortField: 'numip',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
];
